import styled from "@emotion/native"
import Megaphone from "../assets/v2/Megaphone.svg"
import CloseIcon from "../assets/close-icon.svg"
import { ButtonV2, Spacing, Text } from "../ui-components"
import { Platform } from "react-native"
import { SafeAreaView } from "../ui-components/SafeAreaView"

type FullScreenErrorProps = {
  label: string
  message: string
  buttonLabel: string
  onPress: () => void
  nodeUnderButton?: React.ReactNode
  onClose?: () => void
}

export function FullScreenErrorV2({
  label,
  buttonLabel,
  message,
  onPress,
  onClose,
  nodeUnderButton,
}: FullScreenErrorProps) {
  return (
    <Wrapper>
      <ContentContainer>
        <CloseIconContainer onPress={onClose ?? onPress}>
          <CloseIcon color="#1F1C22" />
        </CloseIconContainer>
        <MiddleContent>
          <Megaphone />
          <Spacing top={32} />
          <Text fontSize={36} lineHeight={43.2} fontFamily="IBMPlexSans-SemiBold" align="center">
            {label}
          </Text>
          <Spacing top={12} />
          <Spacing left={20} right={20}>
            <Text fontSize={20} lineHeight={32} color="gray800" align="center">
              {message}
            </Text>
          </Spacing>
        </MiddleContent>
        <ButtonWrapper>
          <ButtonV2 title={buttonLabel} onPress={onPress} variant="blue2" />
          {nodeUnderButton}
          {Platform.OS !== "ios" && <Spacing top={20} />}
        </ButtonWrapper>
      </ContentContainer>
    </Wrapper>
  )
}

const Wrapper = styled.View`
  flex: 1;
  background-color: white;
`

const ContentContainer = styled(SafeAreaView)`
  flex: 1;
  max-width: 500px;
  width: 100%;
  align-self: center;
  justify-content: space-between;
`

const ButtonWrapper = styled.View`
  margin-left: 20px;
  margin-right: 20px;
`

const CloseIconContainer = styled.Pressable`
  width: 46px;
  height: 46px;
  border-radius: 100px;
  background-color: ${({ theme }) => theme.errorScreen.closeIconContainer};
  align-items: center;
  justify-content: center;
  align-self: flex-end;
  margin-right: 20px;
`

const MiddleContent = styled.View`
  margin: 0 20px;
  align-items: center;
`
